'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackButton = function (_Component) {
    (0, _inherits3.default)(BackButton, _Component);

    function BackButton() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BackButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BackButton.__proto__ || (0, _getPrototypeOf2.default)(BackButton)).call.apply(_ref, [this].concat(args))), _this), _this.backButton = function () {
            window.location = (0, _config2.default)().url.root({});
            return false;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BackButton, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'cartFooter w100' },
                _react2.default.createElement(
                    'div',
                    { className: 'box-footer' },
                    _react2.default.createElement(
                        'div',
                        { className: 'pull-left' },
                        _react2.default.createElement(
                            'a',
                            { href: '#', onClick: this.backButton, className: 'btn btn-default' },
                            _react2.default.createElement('i', { className: 'fa fa-arrow-left' }),
                            ' \xA0 ',
                            (0, _localize2.default)("App:ContinueShopping")
                        )
                    )
                )
            );
        }
    }]);
    return BackButton;
}(_react.Component);

exports.default = BackButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/BackButton.js
// module id = 897
// module chunks = 0